//export const BASE_URL ='http://localhost:5000/api/v1/';
//export const IMAGE_BASE_URL ='http://localhost:5000';

//export const BASE_URL ='https://cs-api.roshtech.co.ke/api/v1/';
//export const IMAGE_BASE_URL ='https://cs-api.roshtech.co.ke';

export const BASE_URL ='https://churchsuite-demo-api.roshtech.co.ke/api/v1/';
export const IMAGE_BASE_URL ='https://churchsuite-demo-api.roshtech.co.ke';


